// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as SuccessWithNoContentEntityMapper from "../entity-mapper/SuccessWithNoContentEntityMapper.bs.js";
import * as ManualEditOrderReasonsEntityMapper from "../entity-mapper/ManualEditOrderReasonsEntityMapper.bs.js";
import * as OrderCancellationReasonsEntityMapper from "../entity-mapper/OrderCancellationReasonsEntityMapper.bs.js";

var execute = ManualEditOrderReasonsEntityMapper.execute;

var ManualEditOrderReasonsResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var ManualEditOrderReasonsResponseConverter = partial_arg(ManualEditOrderReasonsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = OrderCancellationReasonsEntityMapper.execute;

var OrderCancellationReasonsResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var OrderCancellationReasonsResponseConverter = partial_arg$1(OrderCancellationReasonsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = SuccessWithNoContentEntityMapper.execute;

var UpdateActualPartnerCollectedCashResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateActualPartnerCollectedCashResponseConverter = partial_arg$2(UpdateActualPartnerCollectedCashResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = SuccessWithNoContentEntityMapper.execute;

var UpdateHasWaypointsConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateHasWaypointsResponseConverter = partial_arg$3(UpdateHasWaypointsConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = SuccessWithNoContentEntityMapper.execute;

var UpdateDryRunDistanceConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateDryRunDistanceResponseConverter = partial_arg$4(UpdateDryRunDistanceConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = SuccessWithNoContentEntityMapper.execute;

var UpdateOrderStatusConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateOrderStatusResponseConverter = partial_arg$5(UpdateOrderStatusConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$6 = SuccessWithNoContentEntityMapper.execute;

var CancelOrderConverterConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var CancelOrderResponseConverter = partial_arg$6(CancelOrderConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$7 = SuccessWithNoContentEntityMapper.execute;

var UpdateDeliveryNoteConverterConfig = {
  execute: execute$7
};

var partial_arg$7 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateDeliveryNoteResponseConverter = partial_arg$7(UpdateDeliveryNoteConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  ManualEditOrderReasonsResponseConverterConfig ,
  ManualEditOrderReasonsResponseConverter ,
  OrderCancellationReasonsResponseConverterConfig ,
  OrderCancellationReasonsResponseConverter ,
  UpdateActualPartnerCollectedCashResponseConverterConfig ,
  UpdateActualPartnerCollectedCashResponseConverter ,
  UpdateHasWaypointsConverterConfig ,
  UpdateHasWaypointsResponseConverter ,
  UpdateDryRunDistanceConverterConfig ,
  UpdateDryRunDistanceResponseConverter ,
  UpdateOrderStatusConverterConfig ,
  UpdateOrderStatusResponseConverter ,
  CancelOrderConverterConfig ,
  CancelOrderResponseConverter ,
  UpdateDeliveryNoteConverterConfig ,
  UpdateDeliveryNoteResponseConverter ,
  
}
/* ManualEditOrderReasonsResponseConverter Not a pure module */
